// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build
// @ts-nocheck
import { fullFormats as formats } from 'ajv-formats/dist/formats.js';
import { countCodePoints } from '#runtime/validation/index.ts';
export const validateCreateDemoUserRequestPayload = validate52;
const schema19 = {
  $ref: 'urn:cascade:contract#/$defs/CreateDemoUserRequestPayload',
};
const schema21 = {
  type: 'object',
  properties: {
    placeholder: { description: 'Unused placeholder field', type: 'string' },
  },
};
function validate54(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate54.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.placeholder !== undefined) {
      if (typeof data.placeholder !== 'string') {
        const err0 = {
          instancePath: instancePath + '/placeholder',
          schemaPath: '#/properties/placeholder/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  } else {
    const err1 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate54.errors = vErrors;
  return errors === 0;
}
validate54.evaluated = {
  props: { placeholder: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate52(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate52.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate54(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
    errors = vErrors.length;
  }
  validate52.errors = vErrors;
  return errors === 0;
}
validate52.evaluated = {
  props: { placeholder: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateGetEmailOidcRequestPayload = validate56;
const schema22 = {
  $ref: 'urn:cascade:contract#/$defs/GetEmailOidcRequestPayload',
};
const schema23 = {
  type: 'object',
  properties: { email: { type: 'string' } },
  required: ['email'],
};
function validate57(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate57.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.email === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'email' },
        message: "must have required property '" + 'email' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.email !== undefined) {
      if (typeof data.email !== 'string') {
        const err1 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
  } else {
    const err2 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate57.errors = vErrors;
  return errors === 0;
}
validate57.evaluated = {
  props: { email: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate56(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate56.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate57(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
    errors = vErrors.length;
  }
  validate56.errors = vErrors;
  return errors === 0;
}
validate56.evaluated = {
  props: { email: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateLoginCallbackRequestPayload = validate59;
const schema24 = {
  $ref: 'urn:cascade:contract#/$defs/LoginCallbackRequestPayload',
};
const schema25 = {
  description:
    'Exactly one of code or magic_auth_code must be supplied. magic_auth_code also requires email.',
  type: 'object',
  properties: {
    code: {
      description:
        'Authorization code from the AuthKit, SSO or Microsoft redirect',
      type: 'string',
    },
    email: {
      description: 'Required alongside magic_auth_code',
      type: 'string',
    },
    magic_auth_code: {
      description: 'Code from a magic link, used instead of code',
      type: 'string',
    },
  },
};
function validate60(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate60.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.code !== undefined) {
      if (typeof data.code !== 'string') {
        const err0 = {
          instancePath: instancePath + '/code',
          schemaPath: '#/properties/code/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.email !== undefined) {
      if (typeof data.email !== 'string') {
        const err1 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.magic_auth_code !== undefined) {
      if (typeof data.magic_auth_code !== 'string') {
        const err2 = {
          instancePath: instancePath + '/magic_auth_code',
          schemaPath: '#/properties/magic_auth_code/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate60.errors = vErrors;
  return errors === 0;
}
validate60.evaluated = {
  props: { code: true, email: true, magic_auth_code: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate59(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate59.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate60(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
    errors = vErrors.length;
  }
  validate59.errors = vErrors;
  return errors === 0;
}
validate59.evaluated = {
  props: { code: true, email: true, magic_auth_code: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateLoginRequestPayload = validate62;
const schema26 = { $ref: 'urn:cascade:contract#/$defs/LoginRequestPayload' };
const schema27 = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
    },
    platform: { type: 'string', enum: ['app', 'portal'] },
  },
  required: ['email', 'platform'],
};
const pattern3 = new RegExp(
  "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
  'u',
);
function validate63(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate63.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.email === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'email' },
        message: "must have required property '" + 'email' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.platform === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'platform' },
        message: "must have required property '" + 'platform' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.email !== undefined) {
      let data0 = data.email;
      if (typeof data0 === 'string') {
        if (!pattern3.test(data0)) {
          const err2 = {
            instancePath: instancePath + '/email',
            schemaPath: '#/properties/email/pattern',
            keyword: 'pattern',
            params: {
              pattern:
                "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
            },
            message:
              'must match pattern "' +
              "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$" +
              '"',
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.platform !== undefined) {
      let data1 = data.platform;
      if (typeof data1 !== 'string') {
        const err4 = {
          instancePath: instancePath + '/platform',
          schemaPath: '#/properties/platform/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (!(data1 === 'app' || data1 === 'portal')) {
        const err5 = {
          instancePath: instancePath + '/platform',
          schemaPath: '#/properties/platform/enum',
          keyword: 'enum',
          params: { allowedValues: schema27.properties.platform.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
  } else {
    const err6 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
  }
  validate63.errors = vErrors;
  return errors === 0;
}
validate63.evaluated = {
  props: { email: true, platform: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate62(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate62.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate63(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
    errors = vErrors.length;
  }
  validate62.errors = vErrors;
  return errors === 0;
}
validate62.evaluated = {
  props: { email: true, platform: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateLoginWithOidcRequestPayload = validate65;
const schema28 = {
  $ref: 'urn:cascade:contract#/$defs/LoginWithOidcRequestPayload',
};
const schema29 = {
  type: 'object',
  properties: {
    oidc: { type: 'string' },
    platform: { type: 'string', enum: ['app', 'portal'] },
  },
  required: ['oidc', 'platform'],
};
function validate66(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate66.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.oidc === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'oidc' },
        message: "must have required property '" + 'oidc' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.platform === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'platform' },
        message: "must have required property '" + 'platform' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.oidc !== undefined) {
      if (typeof data.oidc !== 'string') {
        const err2 = {
          instancePath: instancePath + '/oidc',
          schemaPath: '#/properties/oidc/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.platform !== undefined) {
      let data1 = data.platform;
      if (typeof data1 !== 'string') {
        const err3 = {
          instancePath: instancePath + '/platform',
          schemaPath: '#/properties/platform/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if (!(data1 === 'app' || data1 === 'portal')) {
        const err4 = {
          instancePath: instancePath + '/platform',
          schemaPath: '#/properties/platform/enum',
          keyword: 'enum',
          params: { allowedValues: schema29.properties.platform.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate66.errors = vErrors;
  return errors === 0;
}
validate66.evaluated = {
  props: { oidc: true, platform: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate65(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate65.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate66(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
    errors = vErrors.length;
  }
  validate65.errors = vErrors;
  return errors === 0;
}
validate65.evaluated = {
  props: { oidc: true, platform: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateRevokeRefreshTokenRequestPayload = validate68;
const schema30 = {
  $ref: 'urn:cascade:contract#/$defs/RevokeRefreshTokenRequestPayload',
};
const schema31 = {
  type: 'object',
  properties: {
    placeholder: { description: 'Unused placeholder field', type: 'string' },
  },
};
function validate69(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate69.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.placeholder !== undefined) {
      if (typeof data.placeholder !== 'string') {
        const err0 = {
          instancePath: instancePath + '/placeholder',
          schemaPath: '#/properties/placeholder/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
  } else {
    const err1 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate69.errors = vErrors;
  return errors === 0;
}
validate69.evaluated = {
  props: { placeholder: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate68(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate68.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate69(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
    errors = vErrors.length;
  }
  validate68.errors = vErrors;
  return errors === 0;
}
validate68.evaluated = {
  props: { placeholder: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateSendSignInLinkToEmailRequestPayload = validate71;
const schema32 = {
  $ref: 'urn:cascade:contract#/$defs/SendSignInLinkToEmailRequestPayload',
};
const schema33 = {
  type: 'object',
  properties: {
    action_code_settings: {
      $ref: 'urn:cascade:contract#/$defs/ActionCodeSettings',
    },
    captcha_token: { type: 'string' },
    email: { type: 'string' },
  },
  required: ['email', 'action_code_settings'],
};
const schema34 = {
  type: 'object',
  properties: { handleCodeInApp: { type: 'boolean' }, url: { type: 'string' } },
  required: ['url'],
};
function validate73(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate73.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.url === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'url' },
        message: "must have required property '" + 'url' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.handleCodeInApp !== undefined) {
      if (typeof data.handleCodeInApp !== 'boolean') {
        const err1 = {
          instancePath: instancePath + '/handleCodeInApp',
          schemaPath: '#/properties/handleCodeInApp/type',
          keyword: 'type',
          params: { type: 'boolean' },
          message: 'must be boolean',
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.url !== undefined) {
      if (typeof data.url !== 'string') {
        const err2 = {
          instancePath: instancePath + '/url',
          schemaPath: '#/properties/url/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
  } else {
    const err3 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err3];
    } else {
      vErrors.push(err3);
    }
    errors++;
  }
  validate73.errors = vErrors;
  return errors === 0;
}
validate73.evaluated = {
  props: { handleCodeInApp: true, url: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate72(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate72.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.email === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'email' },
        message: "must have required property '" + 'email' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.action_code_settings === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'action_code_settings' },
        message: "must have required property '" + 'action_code_settings' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.action_code_settings !== undefined) {
      if (
        !validate73(data.action_code_settings, {
          instancePath: instancePath + '/action_code_settings',
          parentData: data,
          parentDataProperty: 'action_code_settings',
          rootData,
          dynamicAnchors,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate73.errors
            : vErrors.concat(validate73.errors);
        errors = vErrors.length;
      }
    }
    if (data.captcha_token !== undefined) {
      if (typeof data.captcha_token !== 'string') {
        const err2 = {
          instancePath: instancePath + '/captcha_token',
          schemaPath: '#/properties/captcha_token/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.email !== undefined) {
      if (typeof data.email !== 'string') {
        const err3 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate72.errors = vErrors;
  return errors === 0;
}
validate72.evaluated = {
  props: { action_code_settings: true, captcha_token: true, email: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate71(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate71.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate72(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate72.errors : vErrors.concat(validate72.errors);
    errors = vErrors.length;
  }
  validate71.errors = vErrors;
  return errors === 0;
}
validate71.evaluated = {
  props: { action_code_settings: true, captcha_token: true, email: true },
  dynamicProps: false,
  dynamicItems: false,
};
